<template>

    <head>
        <title>404 Not Found | Map of Community Weather Monitoring</title>
    </head>
    <section class="font-sans text-zinc-900 antialiased">
        <div class="grid min-h-screen place-items-center bg-zinc-100 p-4 lg:p-6">
            <div class="text-center">
                <p class="text-2xl lg:text-3xl font-bold">404</p>
                <h1 class="mt-4 text-4xl lg:text-5xl font-bold tracking-tight">
                    Page not found
                </h1>
                <p class="mt-6 mx-6 text-base leading-7 text-gray-600">
                    Sorry, we couldn't find the page you're looking for.
                </p>
                <div class="mt-6 flex items-center justify-center gap-x-6">
                    <Link :href="route('home')"
                        class="rounded-md bg-zinc-900 px-4 py-2 text-sm font-semibold text-zinc-100 shadow-sm hover:bg-zinc-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-900">
                    Go back home</Link>
                    <a href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=admin@sinaubumi.org" target="_blank"
                        rel="noopener noreferrer"
                        class="inline-flex items-center justify-center text-sm font-bold">Contact Support<svg
                            class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                clip-rule="evenodd"></path>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { Head, Link } from "@inertiajs/vue3";

export default {
    components: {
        Head,
        Link,
    },
};
</script>
